import React, { useEffect, useState } from 'react';

import { useFormikContext } from 'formik';

import {
  DELIVERY_BASED,
  DELIVERY_BASED_LABELS,
  DISPLAY_CONDITIONS,
  FILTERS_BASED,
  FILTERS_BASED_LABELS,
} from '../../../../constants/tasks';
import DisplayConditions from '../../../Common/DisplayConditions';
import Switcher from '../../../Common/Switcher';
import useMutateTriggers from '../MutateTaskTriggers/MutateTriggerList/hooks/useMutateTriggers';

import './index.scss';

const MutateDisplayConditions = () => {
  const { addTrigger, removeAllTriggers } = useMutateTriggers();

  const filterOptionsData = {
    users: {
      value: FILTERS_BASED.USERS,
      label: FILTERS_BASED_LABELS[FILTERS_BASED.USERS],
    },
    homes: {
      value: FILTERS_BASED.HOMES,
      label: FILTERS_BASED_LABELS[FILTERS_BASED.HOMES],
    },
    triggers: {
      value: FILTERS_BASED.TRIGGERS,
      label: FILTERS_BASED_LABELS[FILTERS_BASED.TRIGGERS],
    },
  };
  const [, setFilterBasedOn] = useState(FILTERS_BASED.USERS);
  const [filterOptions, setFilterOptions] = useState([
    filterOptionsData.users,
    filterOptionsData.triggers,
  ]);
  const { values, setFieldValue } = useFormikContext();
  const userOptions = [
    {
      value: DELIVERY_BASED.USER,
      label: DELIVERY_BASED_LABELS[DELIVERY_BASED.USER],
    },
    {
      value: DELIVERY_BASED.HOME,
      label: DELIVERY_BASED_LABELS[DELIVERY_BASED.HOME],
    },
  ];

  const deliveryOptionsStart = [
    {
      type: DISPLAY_CONDITIONS.START,
      value: '',
    },
    {
      type: DISPLAY_CONDITIONS.DATE,
      value: '',
    },
    {
      type: DISPLAY_CONDITIONS.SUGGESTED_ACTION_END,
      value: '',
    },
  ];

  const deliveryOptionsEnd = [
    {
      type: DISPLAY_CONDITIONS.NEVER,
      value: '',
    },
    {
      type: DISPLAY_CONDITIONS.DATE,
      value: '',
    },
    {
      type: DISPLAY_CONDITIONS.TAP,
      value: '',
    },
    {
      type: DISPLAY_CONDITIONS.SUGGESTED_ACTION_END,
      value: '',
    },
  ];

  useEffect(
    () => {
      if (
        values.displayConditions &&
        values.displayConditions.based &&
        values.displayConditions.based === DELIVERY_BASED.USER &&
        !values.rules.conditions
      ) {
        setFilterBasedOn(FILTERS_BASED.USERS);
        setFilterOptions([filterOptionsData.users, filterOptionsData.triggers]);
        setFieldValue('displayConditions.filter', FILTERS_BASED.USERS);
      }

      if (
        values.displayConditions &&
        values.displayConditions.based &&
        values.displayConditions.based === DELIVERY_BASED.HOME &&
        !values.rules.conditions
      ) {
        setFilterBasedOn(FILTERS_BASED.HOMES);
        setFilterOptions([filterOptionsData.homes, filterOptionsData.triggers]);
        setFieldValue('displayConditions.filter', FILTERS_BASED.HOMES);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [values.displayConditions.based],
  );

  useEffect(
    () => {
      if (
        values.name &&
        values.displayConditions &&
        values.displayConditions.filter &&
        values.displayConditions.filter === FILTERS_BASED.TRIGGERS &&
        ((values.rules.conditions && values.rules.conditions.length === 0) ||
          Object.keys(values.rules).length === 0)
      ) {
        setFieldValue('rules', {
          type: 'union',
          connectiveType: 'and',
          conditions: [],
        });
        removeAllTriggers(setFieldValue);
        addTrigger(setFieldValue, 'home.type', values.triggers);
      } else if (
        values.displayConditions &&
        values.displayConditions.filter &&
        values.displayConditions.filter !== FILTERS_BASED.TRIGGERS
      ) {
        setFieldValue('rules', {});
        removeAllTriggers(setFieldValue);
        addTrigger(setFieldValue, 'home.type', values.triggers);
      }
      setTimeout(() => {
        setFieldValue('name', values.name);
      }, 1);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [values.displayConditions.filter],
  );

  return (
    <>
      <h3 className="mutate-display-conditions-heading">Delivery based on</h3>
      <Switcher name="displayConditions.based" options={userOptions} />
      <h3 className="mutate-display-conditions-heading">Filter</h3>
      <Switcher name="displayConditions.filter" options={filterOptions} />
      <h3 className="mutate-display-conditions-heading">Start delivery</h3>
      <DisplayConditions
        name="displayConditions.conditions.start"
        options={deliveryOptionsStart}
        type={values.type}
      />
      <h3 className="mutate-display-conditions-heading">End delivery</h3>
      <DisplayConditions
        name="displayConditions.conditions.end"
        options={deliveryOptionsEnd}
        type={values.type}
      />
    </>
  );
};

export default MutateDisplayConditions;
